import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { PdfService } from '../pdf.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { PaymentService } from '../payment.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth.service';
import { LocationService } from '../location.service';
import { BottomSheet } from '../bottom.sheet';
let k=1;
@Component({
  selector: 'app-manage-request',
  templateUrl: './manage-request.component.html',
  styleUrls: ['./manage-request.component.scss'],
})
export class ManageRequestComponent  {
  loader:boolean=false;
id;
url;
requests;
dateFormat;
search:any=[];
items:any=[];
enddate;
subsItems;
Subscription:any=[];
change:boolean = false;
cateId = 21;
Orgid;
pModel;
pIdentity;
pColor;
pName;
confirmSubs:boolean = false;
pMake;
serviceInc:boolean;
confirm:boolean;
cancelId;
date=new Date();
category;
cateName = "CAR CARE SERVICES";
filterDate;
filterLength;
pDate;
cancelledReasons;
cancellation;

  constructor(private service: ApiService,
    public handler: HandlerService,
    public pdf: PdfService,
    public bottomSheet: MatBottomSheet,
    public router: Router,
    public payment:PaymentService,
    public translate: TranslateService,
    public auth: AuthService,  public location: LocationService) { }

ionViewWillEnter(){
  this.dateFormat = this.auth.getDateformat();
  this.url = window.location.href;
  this.id = this.url.split('/').pop();  
this.getCategory();
this.getRequests(this.date);
this.getCancelReason();
}

getRequests(date) {
  var dat= this.returnDate(date)
  if(this.filterDate < this.date){
    this.pDate=true;
  }
  else{
    this.pDate=false;
  }
  this.loader= true;
  this.change = false;   
  if(this.url.includes('vendorRequests')){
    this.service.getCustRequestStatus(this.id, this.cateId,dat).subscribe((res: any) => {
      if(res){
      this.items = res;
      this.items.map(res1 => {
        Object.assign(res1, { bikeNumber: res1.custItem.identificationNo })
      })
      this.loader=false;
    }  else{
      this.items=[];
      this.handler.res("No Data Found");
      this.loader = false;
    }
    })

  } else{
    this.service.getAllRequestStatus(this.id, this.cateId,dat).subscribe((res: any) => {
      if(res){
      this.items = res;
      this.items.map(res1 => {
        Object.assign(res1, { bikeNumber: res1.custItem.identificationNo })
      })
      this.loader=false;
    }  else{
      this.items=[];
      this.handler.res("No Data Found");
      this.loader = false;
    }
    })
  } 
      
      }  
               
   
    
    

    getCategory() {
      this.service.getOrgCategory().subscribe((res: any) => {
        this.category = res;
      })
   
    }


    
  openBottomSheet() {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.category,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.cateName = res.name;
        this.cateId = res.id;  
        if(this.change==true){
         this.getSubs();
        } else{
          this.getRequests(this.date);
        }      
  
      }
    });
  }


getSubs(){
  this.loader= true;
  this.change= true;
  this.url = window.location.href;
  this.id = this.url.split('/').pop(); 
  if(this.url.includes('vendorRequests')){
    this.service.getCustomerItemSubsCate(this.id,this.cateId).subscribe((res: any) => {
      if(res){      
      this.Subscription=res;
      this.Subscription.map(res1 => {
        Object.assign(res1, { bikeNumber: res1.custItems[0]?.identificationNo })
      })
      this.loader = false;
     } else{
       this.Subscription=[];
        this.handler.res("No Data Found");
        this.loader = false;
      }
  })

  }else{
    k=1;
    this.service.getVenCustItemSubsCate(this.id,this.cateId,k).subscribe((res: any) => {
      if(res){      
      this.Subscription=res;
      this.Subscription.map(res1 => {
        Object.assign(res1, { bikeNumber: res1.custItems[0]?.identificationNo })
      })
      this.loader = false;
     } else{
       this.Subscription=[];
        this.handler.res("No Data Found");
        this.loader = false;
      }
  })
  }    
      
    }    
   
    getId1(data) {
      if (data.custItems) {
        if (data.custItems[0]) {
          return data.custItems[0]?.identificationNo
        }
      }
    }


getId(data) {
  if (data.custItem) {
    if (data.custItem) {
      return data.custItem?.identificationNo
    }
  }else{
    return data.identificationNumber
  }
}

refreshData(event){
  if(!this.change){
    this.ionViewWillEnter();
  }else{
    this.getSubs();
  }
  
  setTimeout(() => {
    event.target.complete();
  }, 1000);
}

ionViewWillLeave(){
  this.search = "";
}

cancelPop(){
  this.loader = false;
  this.confirm = false;
  this.cancelReq();
}



openPop(data) {
  this.serviceInc = true
  if(data.custItem){
    this.pName = data.providerService.name;
    this.pColor = data.custItem.colour;
    this.pMake = data.custItem.make;
    this.pModel = data.custItem.model;
    this.pIdentity = data.custItem.identificationNo; 
  }
}

openPop1(data) {
  this.serviceInc = true
  this.pName = data.services[0].name;
  this.pColor = data.custItems[0].colour;
  this.pMake = data.custItems[0].make;
  this.pModel = data.custItems[0].model;
  this.pIdentity = data.custItems[0].identificationNo;
  var x = data.custItems[0].purchaseDate.split("T")
  this.pDate = x[0].split("-").reverse().join("-")
}

returnDate(data) {
  let date = data.getDate();
  date = date < 10 ? '0' + date : date;
 let month = data.getMonth() + 1;
 month = month < 10 ? '0' + month : month;
 let year = data.getFullYear();
 return year + '-' + month + '-' + date;
}

cancel(id){
  this.cancelId = id;
  this.confirm=true;
}

cancelReq(){
  this.loader = true;
  var post={
    "cancellationReasons":this.cancellation
  }
  this.service.cancelReq(this.cancelId,post).subscribe((res: any) => {
    this.handler.res("Request Cancelled successfully");
    this.confirm =false;
    this.ionViewWillEnter(); 
  
       })
}

clear(){
  this.search="";
}

ngDoCheck(): void {
  this.filterLength = sessionStorage.getItem('len')
}

subscritionByPage($event){
  this.clear();
  this.service.getVenCustItemSubsCate(this.id,this.cateId,k).subscribe((res: any) => {
    res.map(dat=>{
      this.Subscription.push(dat);
    })
    this.Subscription.map(res1 => {
      Object.assign(res1, { bikeNumber: res1.custItems[0]?.identificationNo })
    })
    this.loader = false;
    k++;
  },err=>{
    this.loader = false;
  })
  }

  getCancelReason(){
    this.service.getcancellationReason().subscribe(res =>{ 
      this.cancelledReasons = res;
     
    }) 
  }

  clearArray2(value){
    this.cancellation=value.name;
  }
  
  cancelSubs(id){
    this.cancelId = id;
  this.confirmSubs=true; 
  }

  cancelSubsPop(){
    this.loader = false;
    this.confirmSubs = false;
    this.cancelSubscription();
  }


  
  clearArray1(value){
    this.cancellation=value.name;
  }


  cancelSubscription(){
    this.loader = true;
    this.confirm =false; 
    var post ={
      "endDate":this.returnDate(this.enddate),
      "cancellationReasons":this.cancellation
    }
    this.service.cancelPackageReq(this.cancelId,post).subscribe((res: any) => {
     
      this.handler.res("Subscription Cancelled successfully");   
      this.ionViewWillEnter(); 
          })
  }

}
